/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../authContext";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  IconButton,
  TextField,
  Card,
  CardContent,
  Tooltip,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPrinter,
  mdiReceipt,
  mdiPackageVariant,
  mdiStoreOutline,
  mdiTextBoxMultipleOutline,
  mdiLabel,
  mdiRuler,
  mdiTableColumnWidth,
  mdiTableRowHeight,
  mdiCounter,
  mdiCubeOutline,
  mdiCheck,
  mdiPackageDown,
  mdiMapMarkerCheckOutline,
  mdiPackageVariantClosed,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiTruckFastOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiCurrencyUsd,
  mdiCashMultiple,
  mdiPlusBoxMultiple,
} from "@mdi/js";

// Components
import ListOrderItems from "./list";
import InventoryItemsList from "./inventoryItemsList";
import Can from "../../components/Can";
import PackageList from "./packagesList";

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from "../../utils/rulesOrderStatus";

// Helper
import { translate, formaterPhoneNumber } from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type
import { Status } from "../orders/interfaces";
import { Props } from "./interfaces";
import { Link, useHistory } from "react-router-dom";
import CSV from "./csv";
import { UpdateOrderPostTrackingCode } from "client-sdk/src/orders/orders";
import Client from "client-sdk/src/client";
import Modal from "../../components/Modal";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import orderItemsRepository from "client-sdk/src/Repository/order-items.repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import ListDimensions from "../orderPack/dimensionsList";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@material-ui/lab";
import showDeliveryType from "../../utils/temporaryConditions/showDeliveryType";
import showOrderTplType from "../../utils/temporaryConditions/showOrderTplType";
import getOrderFileReq from "client-sdk/src/orders/files";
import { getBlockingTickets } from "../../api/ticket/get";
import { isEmpty } from "lodash";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    addIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#5c5c5c",
      },
    },
    item: {
      marginBottom: "24px",

      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: "10px",
      flex: 0.5,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    checkIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#039590",
      },
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: "4px 4px 0 0",
    },
    contentBox: {
      marginTop: "-1px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      fontWeight: 500,
      textAlign: "right",
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      alignItems: "center",
    },
    tooltipStyle: {
      fontSize: "20px",
    },
  })
);

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};

export function Details(props: Props) {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState("CANCELLED" as Status);
  const [packPreviewState, setPackPreviewState] = useState(
    "PACKAGED" as Status
  );
  const [ticket, setTicket] = useState(null);
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [openPackConfirmUpdateState, setPackOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openPackages, setOpenPackages] = useState(false as boolean);
  const [openInventoryItems, setOpenInventoryItems] = useState(
    false as boolean
  );
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [boxCount, setBoxCount] = useState("");
  const [height, setHeight] = useState("");
  const [count, setCount] = useState("");
  const [counts, setCounts] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [dimensions, setDimensions] = useState<any>([]);
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [logs, setLogs] = useState([]);

  const classes = useStyles();
  const token = localStorage.getItem("token") || "";
  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height,
    };
    setDimensions([...dimensions, newDimension]);
    setCount("");
    setLength("");
    setHeight("");
    setWidth("");
  };
  const setUpdateStatus = () => {
    setPackOpenConfirmUpdateState(true);
  };
  const handlePackClose = () => {
    setPackOpenConfirmUpdateState(false);
    handleCloseDimensions();
  };
  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount("");
    setOpenListDimensions(false);
    // setDimensions([]);
  };
  const addOrderDimensions = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const callback = await ordersRepository.addOrderDimensions({
        payload,
      });
      callback && callback();
      handleNotfication("تغییر وضعیت سفارش با موفقیت انجام شد", "success");
    } catch (error) {
      setError(error.message);
      handleNotfication("تغییر وضعیت سفارش انجام نشد", "error");
    } finally {
      setLoading(false);
    }
  };
  const addOrderDimension = () => {
    const { id } = props.match.params;
    addOrderDimensions({
      id: order.id,
      body: dimensions,
      callback: () => getOrderWithId(id),
    });
    handlePackClose();
    getOrderWithId(id);
  };
  const checkButtonDisabled = () => {
    const fields = [count, length, width, height];
    return fields.some((field) => !field) && totalBoxCount < Number(boxCount);
  };

  const getOrderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getOrderItems = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const response = await orderItemsRepository.getAllOrderItems({ payload });
      setOrderItems(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const logsGet = async (id: any) => {
    const payload = { id };
    try {
      const response = await ordersRepository.getLogs({ payload });
      setLogs(response.data);
    } catch (error) {
      setError(error.message);
    }
  };
  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);
  useEffect(() => {
    const { id } = props.match.params;
    logsGet(id);
    getOrderWithId(id);
    getOrderItems({ "orderId.equals": id, size: 1000 });
  }, []);

  useEffect(() => {
    if (order?.postTrackingCode) {
      setPostTrackingCode(order?.postTrackingCode);
    }
  }, [order]);
  const clearOrder = async () => {
    setOrder({});
    setOrderItems([]);
  };
  useEffect(() => {
    getTicket();
    return () => {
      clearOrder();
    };
  }, []);

  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({ linkType: "order", linkId: id });
      setTicket(res.data[0]);
      res.data.length > 0 && handleNotfication("سفارش دارای تیکت است.", "warn");
    } catch (error) {
      handleError(error);
    }
  };
  const updateOrderStatus = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { pagination, callback } = await ordersRepository.updateOrderStatus(
        {
          payload,
        }
      );
      callback && callback();
      handleNotfication("تغییر وضعیت سفارش با موفقیت انجام شد", "success");
    } catch (error) {
      setError(error.message);
      handleNotfication("تغییر وضعیت سفارش انجام نشد", "error");
    } finally {
      setLoading(false);
    }
  };
  const changeStatusOrder = () => {
    const { id } = props.match.params;
    updateOrderStatus({
      id: order.id,
      body: previewState.replace(/"/g, ""),
      pagination: {},
      callback: () => getOrderWithId(id),
    });
    handleClose();
  };

  const getInventoryItems = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getAllInventoryItemsWithSerial({
          payload,
        });
      callback && callback();
      setInventoryItems(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication("هیچ آیتمی پیدا نشد.", "warn");
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const handleShowInventoryItems = (data: any) => {
    getInventoryItems({
      orderItemId: { equals: data.id },
      size: 1000,
      callback: () => setOpenInventoryItems(true),
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(order.id, { fileType: type });
      const file = URL.createObjectURL(response.blob);
      return file;
    } catch (error: any) {
      handleError(error);
      return error;
    }
  };

  const downLoadFile = async (type: string, fileName: string) => {
    try {
      const file = await getOrderFile(type);
      const link = document.createElement("a");
      link.href = file;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error: any) {
      //   handleError(error)
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{order.id}</span>
      </div>

      <Grid container style={{ marginBottom: "16px" }}>
        <Grid item md={3}>
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}>
            <Icon path={mdiArrowRight} size={1} className={classes.icon} />
            {"بازگشت"}
          </Button>
        </Grid>
        <Grid
          item
          md={9}
          style={{ display: "flex", flexDirection: "row-reverse" }}>
          <Can
            role={authContext.user.role}
            perform="orders:downloadReportCSV"
            yes={() => (
              <>
                <CSV
                  // ordersDispatch={props.order}
                  data={orderItems}
                  loading={loading}
                />
              </>
            )}
          />
          {order?.status !== "CANCELLED" && (
            <>
              {/* <Can
                role={authContext.user.role}
                perform="orders:addParcel"
                yes={() => (
                  <>
                    <span>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Icon path={mdiPackageDown} size={1} />}
                        onClick={() => setOpenDimensions(true)}
                      >
                        {'اضافه کردن بسته'}
                      </Button>
                    </span>
                  </>
                )}
              /> */}
              <Can
                perform="orderExit:print"
                role={authContext.user.role}
                yes={() => (
                  <Link
                    to={`/orders/exit-receipts/${order.id}`}
                    target="_blank"
                    style={{
                      textDecoration: "none",
                      margin: "0px 10px",
                    }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<Icon path={mdiReceipt} size={1} />}>
                      {"چاپ رسید خروج"}
                    </Button>
                  </Link>
                )}
              />
              {ticket && (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    history.push(`/ticketing/${ticket?.id}`);
                  }}>
                  سابقه تیکت
                </Button>
              )}
            </>
          )}
          {order.receiptUrl && order?.status !== "CANCELLED" && (
            <a
              href={`${order.receiptUrl}`}
              target="_blank"
              style={{ textDecoration: "none", marginLeft: "10px" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}>
                {"چاپ فاکتور سفارش"}
              </Button>
            </a>
          )}
          {order.fulfillmentAttachmentUrl && order?.status !== "CANCELLED" && (
            <a
              href={`${order.fulfillmentAttachmentUrl}`}
              target="_blank"
              style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiLabel} size={1} />}>
                {"چاپ لیبل های سفارش"}
              </Button>
            </a>
          )}
          {order.receiptFileName && order?.status !== "CANCELLED" && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiPrinter} size={1} />}
              onClick={() => downLoadFile("RECEIPT", order.receiptFileName)}>
              دانلود فایل فاکتور
            </Button>
          )}
          {order.labelFileName && order?.status !== "CANCELLED" && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiLabel} size={1} />}
              onClick={() => downLoadFile("LABEL", order.labelFileName)}>
              دانلود فایل لیبل
            </Button>
          )}
          <Can
            perform="orderDetail:print"
            role={authContext.user.role}
            yes={() => (
              <Link
                to={`/orders/receipts/${order.id}`}
                target="_blank"
                style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon path={mdiPrinter} size={1} />}>
                  {authContext.user.role === "WAREHOUSE_OPERATOR" ||
                  authContext.user.role === "WAREHOUSE_ADMIN"
                    ? "چاپ رسید"
                    : "چاپ حواله"}
                </Button>
              </Link>
            )}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" justify="space-between">
        <Grid lg={3}>
          <Card>
            <CardContent>
              <div className={classes.item}>
                <span className={classes.label}>{"وضعیت تحویل :  "}</span>
                <span style={{ flex: 1 }}>
                  <Can
                    role={authContext.user.role}
                    perform="orders:changeOrderStatus"
                    yes={() => (
                      <FormControl style={{ width: "100%" }}>
                        <Icon
                          path={mdiPencilOutline}
                          size={1}
                          className={classes.changStatusIcon}
                        />
                        <Select
                          className={classes.changStatusBox}
                          fullWidth
                          inputProps={{
                            name: "name",
                            id: "uncontrolled-native",
                          }}
                          name={"status"}
                          id={order.rubikaId}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {translate(order.status, "order")}
                            </span>
                          )}>
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={"status"}
                            name={"status$"}
                            value={"item"}
                            onChange={(
                              e: React.ChangeEvent<{
                                value: unknown;
                              }>
                            ) =>
                              handleOpenConfirmUpdateState(
                                `"${e.target.value}"` as Status
                              )
                            }>
                            {rulesOrderStatus[order.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={order.status === item}
                                  value={item}
                                  disabled={
                                    rulesAdminChangeOrderStatus[
                                      authContext.user.role
                                    ].indexOf(item) === -1
                                  }
                                  control={<Radio />}
                                  label={translate(item, "order")}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    )}
                    no={() => <span>{translate(order.status, "order")}</span>}
                  />
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع پردازش:  "}</span>
                <span style={{ flex: 1 }}>
                  {showDeliveryType(order?.deliveryType)}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"ناوگان حمل:  "}</span>
                <span style={{ flex: 1 }}>
                  {showOrderTplType(order?.deliveryType, order?.orderTplType)}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiCashMultiple}
                    size={1}
                    className={classes.icon}
                  />
                  {"شیوه پرداخت:"}
                </span>
                <span dir="ltr">{order?.paymentType}</span>
              </div>
              {order?.paymentType === "COD" && (
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCurrencyUsd}
                      size={1}
                      className={classes.icon}
                    />
                    {"مبلغ فاکتور:  "}
                  </span>
                  <span dir="ltr">{order?.codValue}</span>
                </div>
              )}
              <div className={classes.item}>
                <span className={classes.label}>{"کدپیگیری:  "}</span>
                <span style={{ flex: "1" }}>{order?.trackingCode}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد بسته:  "}</span>
                <p>{order.orderPackages?.length}</p>

                {!isEmpty(order) && (
                  <div>
                    <div
                      style={{ display: "flex", marginRight: "10px" }}
                      dir="ltr">
                      <p style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {order.orderPackages[0]?.packageName}
                      </p>
                    </div>
                  </div>
                )}
                {order?.orderPackages?.length > 1 && (
                  <Tooltip
                    className={classes.tooltipStyle}
                    title={
                      <span>
                        {order?.orderPackages?.map((item: any) => {
                          return (
                            <div
                              dir="ltr"
                              style={{
                                display: "flex",
                                fontSize: " 15px",
                                padding: "5px",
                              }}>
                              <span style={{ marginRight: "10px" }}>
                                {item.packageName}
                              </span>
                            </div>
                          );
                        })}
                      </span>
                    }>
                    <span>
                      <Icon
                        style={{ cursor: "pointer" }}
                        path={mdiPlusBoxMultiple}
                        size={1}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
              <Divider style={{ width: "100%" }} />
            </CardContent>
            <CardContent>
              <div className={classes.item}>
                <span className={classes.label}>{" تاریخ ثبت:  "}</span>
                <span style={{ flex: "1" }}>
                  {order.registrationDate &&
                    `${jMoment(order.registrationDate, "YYYY/MM/DD")
                      .locale("fa")
                      .format("jYYYY/jMM/jDD")}`}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"تاریخ تحویل:  "}</span>
                <span style={{ flex: "1" }}>
                  {order.deliveryDate &&
                    `${jMoment(order.deliveryDate, "YYYY/MM/DD")
                      .locale("fa")
                      .format("jYYYY/jMM/jDD")}`}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{" بازه تحویل:  "}</span>
                <span style={{ flex: "1" }}>
                  {order.deliveryStartTime &&
                    jMoment(order.deliveryStartTime, "hh:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}
                  {" - "}
                  {order.deliveryEndTime &&
                    jMoment(order.deliveryEndTime, "hh:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"استان:  "}</span>
                <span style={{ flex: "1" }}>{order?.customerProvince}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"شهر:  "}</span>
                <span style={{ flex: "1" }}>{order?.customerCity}</span>
              </div>
              <Divider style={{ width: "100%" }} />
            </CardContent>
            <CardContent>
              <div className={classes.item}>
                <span className={classes.label}>{"نام:  "}</span>

                <span style={{ flex: "1" }}>{order.customerName}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{" کد ملی:  "}</span>
                <span style={{ flex: "1" }}>{order?.customerNationalCode}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"شماره همراه:  "}</span>
                <span style={{ flex: "1" }}>
                  {formaterPhoneNumber(order.customerMobileNumber)}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{" شماره ثابت:  "}</span>
                <span style={{ flex: "1", textAlign: "right" }} dir="ltr">
                  {order?.customerPhoneNumber}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label} style={{ alignSelf: "start" }}>
                  {"آدرس:  "}
                </span>
                <span style={{ flex: "1" }}>
                  {order.customerAddress && order.customerAddress}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{" کد پستی:  "}</span>
                <span style={{ flex: "1" }}>{order?.customerZipCode}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.label}>{"توضیحات:  "}</span>
                <span style={{ flex: "1" }}>
                  {order.description && order.description}
                </span>
              </div>
              {order.senderName && (
                <div className={classes.item}>
                  <span className={classes.label}>{"نام فرستنده:"}</span>
                  <span style={{ flex: "1" }}>{order.senderName}</span>
                </div>
              )}
            </CardContent>
          </Card>
          {order?.deliveryType !== "COURIER" && (
            <Card style={{ marginTop: "16px" }}>
              <CardContent>
                {order?.postOrders?.length &&
                  order?.postOrders.map((order, index) => {
                    return (
                      <>
                        <Typography
                          color="secondary"
                          component="h3"
                          variant="h6">
                          بسته پستی {index + 1}
                        </Typography>
                        <div
                          className={classes.item}
                          style={{ marginTop: "16px" }}>
                          <span className={classes.label}>{"وضعیت:  "}</span>
                          <span style={{ flex: "1" }}>
                            {translate(order.postOrderStatus, "order")}
                          </span>
                        </div>
                        <div className={classes.item}>
                          <span className={classes.label}>
                            {"کد رهگیری:  "}
                          </span>
                          <span style={{ flex: "1" }}>{order.barcode}</span>
                        </div>
                        <div className={classes.item}>
                          <span className={classes.label}>
                            {"وزن (گرم):  "}
                          </span>
                          <span style={{ flex: "1" }}>{order.weight}</span>
                        </div>
                        <div className={classes.item}>
                          <span className={classes.label}>
                            {"هزینه (ریال):  "}
                          </span>
                          <span style={{ flex: "1" }}>{order.totalPrice}</span>
                        </div>
                      </>
                    );
                  })}
              </CardContent>
            </Card>
          )}
        </Grid>
        <Grid lg={9}>
          <Card style={{ paddingTop: "0", marginRight: "16px" }}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              order?.items && (
                <>
                  <ListOrderItems
                    data={order.items}
                    showItems={(data) => handleShowInventoryItems(data)}
                  />
                </>
              )
            )}
          </Card>
          <Card style={{ marginRight: "16px", marginTop: "16px" }}>
            <Grid item xs={12}>
              <Timeline align="left" style={{ minWidth: "500px" }}>
                {logs
                  ?.slice()
                  .reverse()
                  .map((log, index: number) => (
                    <TimelineItem
                      className={classes.missingOppositeContent}
                      key={index}>
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: colorStatus[log.newStatus],
                            border: index === 0 ? "solid 4px #DF9234" : "",
                          }}>
                          <Icon path={iconStatus[log.newStatus]} size={1} />
                        </TimelineDot>
                        {index !== logs?.length - 1 ? (
                          <TimelineConnector />
                        ) : (
                          ""
                        )}
                      </TimelineSeparator>
                      <TimelineContent className={classes.paperHistory}>
                        <div style={{ padding: "10px" }}>
                          <div className={classes.contentBox}>
                            <div style={{ flex: 1.5, textAlign: "right" }}>
                              <span className={classes.contentlabel}>
                                وضعیت سفارش:
                              </span>
                              <span data-cy="status">
                                {translate(log.newStatus, "order")}
                              </span>
                            </div>
                            <div
                              style={{
                                flex: 2,
                                textAlign: "right",
                                justifyContent: "center",
                              }}>
                              <span className={classes.contentlabel}>
                                کاربر:
                              </span>
                              <Can
                                role={authContext.user.role}
                                perform="user-name:dontShowInLogs"
                                no={() => (
                                  <>
                                    <span>{log.modifierName}</span>
                                    <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                                  </>
                                )}
                              />
                              <span data-cy="role">
                                {translate(log.modifierRole, "user")}
                              </span>
                              {log.assignee && (
                                <>
                                  <span> &nbsp; &nbsp; &nbsp; &nbsp;</span>
                                  <span className={classes.contentlabel}>
                                    تخصیص به:
                                  </span>
                                  <span>{log.assignee}</span>
                                </>
                              )}
                            </div>
                            <Typography component="div" style={{ flex: 1 }}>
                              {log.time &&
                                jMoment(log.time, "YYYY/MM/DDTHH:mm:ss.SSZ")
                                  .locale("fa")
                                  .format("jYYYY/jMM/jDD - HH:mm")}
                            </Typography>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
              </Timeline>
            </Grid>
          </Card>
        </Grid>
      </Grid>

      <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth="md"
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiStoreOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<InventoryItemsList data={inventoryItems} />}
      />
      <Modal
        maxWidth="xl"
        onClose={() => setOpenPackages(false)}
        open={openPackages}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon
              path={mdiTextBoxMultipleOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<PackageList data={order?.postOrders} />}
      />

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(order.status, "order")}"
        به
       " ${translate(previewState.replace(/"/g, "") as Status, "order")}"


        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openPackConfirmUpdateState}
        onClose={handlePackClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handlePackClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handlePackClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.checkIcon}>
            <Icon path={mdiCheck} size={4} color="#039590" />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر وضعیت سفارش
        به
       " ${translate(packPreviewState.replace(/"/g, "") as Status, "order")}"
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handlePackClose()}
                size="large">
                {"انصراف"}
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button
                fullWidth
                autoFocus
                onClick={addOrderDimension}
                variant="contained"
                color="primary"
                size="large">
                {"تغییر وضعیت سفارش"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.checkIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          {boxCount && openListDimensions ? (
            <Grid container alignItems="center" spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end">
                <Grid item xs={2}>
                  <Icon path={mdiCounter} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end">
                <Grid item xs={2}>
                  <Icon path={mdiTableRowHeight} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="length"
                    name="length"
                    value={length}
                    onChange={(e) => setLength(e.target.value)}
                    label="طول"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end">
                <Grid item xs={2}>
                  <Icon path={mdiTableColumnWidth} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="width"
                    name="width"
                    value={width}
                    onChange={(e) => setWidth(e.target.value)}
                    label="عرض"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end">
                <Grid item xs={2}>
                  <Icon path={mdiRuler} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="height"
                    name="height"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    label="ارتفاع"
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12}>
                <p>{"تعداد بسته بندی های سفارش را وارد کنید"}</p>
              </Grid>
              <Grid item xs={1}>
                <Icon path={mdiCounter} size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id="boxCount"
                  name="boxCount"
                  value={boxCount}
                  onChange={(e) => setBoxCount(e.target.value)}
                  label="تعداد بسته"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handlePackClose()}
                  size="large">
                  {"بازگشت"}
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant="contained"
                  color="primary"
                  disabled={checkButtonDisabled()}
                  size="large">
                  {totalBoxCount >= Number(boxCount)
                    ? "مرحله بعد"
                    : "اضافه کردن بسته"}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handleCloseDimensions()}
                  size="large">
                  {"انصراف"}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant="contained"
                  color="primary"
                  disabled={!boxCount}
                  size="large">
                  {"مرحله بعد"}
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Details;
